import "./GalleriesSlideCard.scss";
import CustomSpinner from "../CustomSpinner/CustomSpinner";
import { nameSlug } from "@/utils/Functions/NameSlug";
import Link from "next/link";
import { GalleryGetResponse } from "@/interfaces/galleries/galleries-response";

interface GalleriesSlideCardPropsI {
  gallery: GalleryGetResponse;
  loading: boolean;
}

function GalleriesSlideCard(props: GalleriesSlideCardPropsI) {
  const { loading, gallery } = props;

  if (loading) {
    return (
      <div className="galleries-slide-card loading">
        <CustomSpinner size={5} borderWidth={3} />
      </div>
    );
  }

  return (
    <Link href={"/" + nameSlug(gallery.name)}>
      <div className="galleries-slide-card relative w-full rounded-[10px] overflow-hidden h-full cursor-pointer group">
        <img
          src={gallery.avatar}
          alt={gallery.name}
          className="w-full object-cover h-full"
        />

        {/* group-info: Siempre visible en mobile, solo en hover en desktop */}
        <div
          className="group-info absolute bottom-0 left-0 w-full z-50 duration-300
                    opacity-100 lg:opacity-0 lg:group-hover:opacity-100"
        >
          <div className="flex flex-col">
            {gallery.photosCoolRare && gallery.photosCoolRare > 0 ? (
              <h3 className="text-[1.2rem] lg:text-[2rem] orange-color text-center lg:hidden m-0 text-white">
                C/R: {gallery.photosCoolRare}
              </h3>
            ) : null}
            {gallery.photosExclusive && gallery.photosExclusive > 0 ? (
              <h3 className="font-sm orange-color text-center lg:hidden">
                Ex: {gallery.photosExclusive}
              </h3>
            ) : null}
          </div>
          <div className="bg-black bg-opacity-80 p-3 lg:opacity-0 lg:group-hover:opacity-100">
            <h3 className="text-[1.2rem] lg:text-[2rem] text-white text-center m-0">
              {gallery.name}
            </h3>
            <h4 className="text-[1.2rem] lg:text-[2rem] text-white text-center m-0">
              {gallery.photos} images
            </h4>
          </div>
        </div>

        {/* data-h: Visible por defecto en desktop, se oculta en hover */}
        <div
          className="data-h flex-col absolute bottom-0 p-2 hidden lg:flex 
                    opacity-100 group-hover:opacity-0 duration-300"
        >
          {gallery.photosCoolRare && gallery.photosCoolRare > 0 ? (
            <p className="orange-color font-bold">
              C/R: {gallery.photosCoolRare}
            </p>
          ) : null}
          {gallery.photosExclusive && gallery.photosExclusive > 0 ? (
            <p className="orange-color font-bold">
              Ex: {gallery.photosExclusive}
            </p>
          ) : null}
        </div>
      </div>
    </Link>
  );
}

export default GalleriesSlideCard;
